import { createContext } from 'react';

/**
 * Çağrı context'i sadece medya stream'leri, cihaz listesi ve stabil aksiyonları
 * taşır. Yüksek frekanslı çağrı state'i (activeCall, callStatus, connectionState,
 * flag'ler, callDuration, callError, pendingSignals) `useCallStore` üzerinden
 * selector ile okunmalıdır; bu sayede context value memo'lanabilir ve 1 Hz
 * callDuration tick'i context tüketicilerini re-render etmez.
 */
export interface CallContextType {
  localStream: MediaStream | null;
  remoteStream: MediaStream | null;
  audioOutputDevices: MediaDeviceInfo[];

  subscribeToConversation: (conversationId: number) => void;
  unsubscribeFromConversation: (conversationId: number) => void;
  initiateCall: (conversationId: number, callType?: 'audio' | 'video', targetUserId?: number) => Promise<void>;
  acceptCall: (callId: number) => Promise<void>;
  rejectCall: (callId: number) => Promise<void>;
  endCall: (callId: number) => Promise<void>;
  toggleMute: () => void;
  toggleVideo: () => void;
  toggleSpeaker: () => Promise<void>;
  switchCamera: () => Promise<void>;
  toggleLocalVideoSize: () => void;
  setRemoteAudioElement: (element: HTMLAudioElement | null) => void;
  clearCallError: () => void;
  resetCallState: () => void;
}

export const CallContext = createContext<CallContextType | undefined>(undefined);
